module.exports = __webpack_public_path__ + "static/media/bot.910b6dbc.png";